import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import ProductDetails from './shop-components/shop-details';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
// import data from "../../data/mainData.json";
import data from "../../src/data/mainData.json"

const Product_Details = () => {
    const property = data?.propertyDetails?.find(item => item.slug_name === "cheran_nagar_phase_1");
    return <div>
        <Navbar />
        <PageHeader 
            headertitle={property?.title} 
            customclass="mb-0" 
            />
        <ProductDetails />
        <CallToActionV1 />
        <Footer />
    </div>
}

export default Product_Details

